import { createBuilderModule } from '../../builder';
import { Margin } from './Margin';
import { withChildren } from '@builder.io/react';

export default createBuilderModule(withChildren(Margin), {
  name: 'Margin',
  image: 'https://cdn.icon-icons.com/icons2/1369/PNG/512/-space-bar_90666.png',
  inputs: [
    {
      name: 'marginTop',
      type: 'number',
    },
    {
      name: 'marginRight',
      type: 'number',
    },
    {
      name: 'marginBottom',
      type: 'number',
    },
    {
      name: 'marginLeft',
      type: 'number',
    },
  ],
});
